<script setup>
</script>

<template>
  <div class="trust">
    <div class="container">
      <div class="trust__wrapper">
        <div class="trust__wrapper-left">
          <h2>Security You Can Trust</h2>
          <p>
            Gold-Charge is built with multiple layers of protection — from advanced
            fraud detection and tokenization to 24/7 monitoring and compliance with PCI
            DSS, GDPR, and AML standards.
          </p>
          <h3>Your business and your customers are safe with us.</h3>
        </div>
        <div class="trust__wrapper-right">
          <img src="@images/trust-image.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
h2 {
  color: #46302e;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 36px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
  text-align: left;
}

h3 {
  color: #46302e;
  text-align: center;
  font-family: "Libre Caslon Text", sans-serif;
  font-size: 20px;
  font-style: italic;
  font-weight: 500;
  line-height: normal;
}

p {
  color: #46302e;
  font-family: "Didact Gothic", sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 559px;
  text-align: justify;
}

img {
  width: 631px;
  margin-right: -160px;
  max-width: 100%;
  height: auto;
}

.trust {
  position: relative;
  z-index: 2;
  padding-top: 80px;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 67px;

    &-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 50px;
    }
  }
}

/* ——— АДАПТИВ ——— */

@media (max-width: 1024px) {
  .trust__wrapper {
    flex-direction: column-reverse;
    text-align: center;
    gap: 40px;

    &-left {
      align-items: center;
      gap: 30px;
    }

    img {
      margin-right: 0;
      width: 500px;
    }

    p {
      width: 90%;
    }
  }
}

@media (max-width: 768px) {
  h2 {
    font-size: 30px;
  }

  p {
    font-size: 18px;
    width: 100%;
  }

  h3 {
    font-size: 18px;
  }

  img {
    width: 400px;
  }
}

@media (max-width: 480px) {
  .trust__wrapper {
    gap: 25px;
  }

  h2 {
    font-size: 26px;
    text-align: center;
  }

  p {
    font-size: 16px;
    text-align: center;
  }

  h3 {
    font-size: 16px;
  }

  img {
    width: 100%;
    margin: 0 auto;
  }
}
</style>
